import { Modal, Form, Button, Table } from "react-bootstrap";
import "./../assets/scss/new-entity-modal.scss";
import Select from "react-select";
import { useQuery } from "react-query";
import queryString from "query-string";
import { useState, useEffect, useCallback } from "react";

import { useAuth } from "../hooks/useAuth";
import { fetchActionsUtil } from "../utils/helpers";
import useDebounce, { useQueryParams } from "./../utils/hooks";
import MultiRangeSlider from "./MultiRangeSlider";

const initialFilterParams = {
  q: "",
  cert: "",
  job: "",
  maxRange: 0,
  minRange: 0,
  hasAllJobs: false,
  hasAllCerts: false,
  enablePriceRange: false,
  status: true,
  verified: true,
};

export default function VendorAdvanceSearchModal({
  showAdvanceSearch,
  setAdvanceSearch,
  setData,
  setShowSelect,
  setSelectedAllData,
  setSelectedData,
  handleAdvanceSearchSelect,
}) {
  const [queryParams, setQueryParams] = useQueryParams({
    ...initialFilterParams,
  });
  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });
  const debouncedFilterParams = useDebounce(filterParams, 500);

  const { backendUrl, token } = useAuth();
  const [jobsValue, setJobsValue] = useState([]);
  const [certValue, setCertValue] = useState([]);
  const [initialRanges, setInitialRanges] = useState({ max: 0, min: 0 });
  const [max, setMax] = useState();
  const [min, setMin] = useState();

  const [selectedData, setOnSelectedData] = useState([]);

  const getCustomer = async (debouncedqueryParams) => {
    const { data } = await fetchActionsUtil(
      `${backendUrl}/api/vendors?${queryString.stringify(
        debouncedqueryParams,
      )}`,
      "GET",
      token,
    );

    const vendorData = await fetchActionsUtil(
      `${backendUrl}/api/vendors/vendor-data`,
      "GET",
    );

    setInitialRanges({
      max: vendorData?.maxRange,
      min: vendorData?.minRange,
    });

    const vendorCert = vendorData?.vendorCert?.map((el) => ({
      value: el,
      label: el,
    }));
    const vendorJobs = vendorData?.vendorJobs?.map((el) => ({
      value: el,
      label: el,
    }));

    data.vendorData = vendorData;
    data.vendorJobs = vendorJobs;

    data.vendorCert = vendorCert;

    // console.log(data);

    setData && setData(data);

    return data;
  };

  const { data } = useQuery(
    ["GET all the vendors", debouncedFilterParams],
    () => getCustomer(debouncedFilterParams),
    {
      enabled: true,
      keepPreviousData: true,
    },
  );

  const handleFilterParamsChange = (e) => {
    setFilterParams({
      ...filterParams,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const searchSelect = (name, value) => {
    const el = value.map((el) => el.value);
    if (name === "job") setJobsValue(value);
    if (name === "cert") setCertValue(value);

    setFilterParams({
      ...filterParams,
      [name]: el,
    });
  };

  useEffect(() => {
    setQueryParams((p) => ({ ...p, ...filterParams }));
  }, [filterParams, setQueryParams]);

  const reset = () => {
    if (handleAdvanceSearchSelect) {
      handleAdvanceSearchSelect([]);
      setOnSelectedData([]);
    } else {
      setSelectedAllData([]);
      setSelectedData([]);
      setShowSelect(false);
    }

    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
    setJobsValue([]);
    setCertValue([]);
  };

  useEffect(() => {
    setFilterParams((f) => ({
      ...f,
      maxRange: max,
      minRange: min,
    }));
  }, [min, max]);

  const onSelected = useCallback((userId) => {
    // Toggle userId in setOnSelectedData
    setOnSelectedData((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId],
    );
  }, []);

  const AddSelected = () => {
    if (handleAdvanceSearchSelect) {
      handleAdvanceSearchSelect(selectedData);
    } else {
      setShowSelect(true);
    }

    setAdvanceSearch(false);
  };

  return (
    <Modal
      show={showAdvanceSearch}
      onHide={() => setAdvanceSearch(false)}
      centered={true}
      animation={false}
      enforceFocus={false}
      className="md"
    >
      <Modal.Header>
        <Modal.Title>
          <h5>Advance Vendor Search</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="filter-header" />
          <div className="filter-body">
            <Form>
              <div className="body">
                <div className="input-group mb-3">
                  <Form.Control
                    id="queryParams-q"
                    className=""
                    name="q"
                    value={filterParams?.q}
                    onChange={(e) => handleFilterParamsChange(e)}
                    placeholder="Search by name"
                  />
                </div>
                <Form.Group className="mb-3">
                  <Form.Label>
                    <b>Search by Certificate</b>
                    <Form.Check
                      className="mx-3"
                      inline
                      label="Has all certs"
                      name="hasAllCerts"
                      type={"checkbox"}
                      id={`hasAllCerts`}
                      defaultChecked={JSON.parse(
                        filterParams?.hasAllCerts || false,
                      )}
                      onChange={(e) => handleFilterParamsChange(e)}
                    />
                  </Form.Label>

                  <Select
                    isMulti
                    classNamePrefix={"form-select"}
                    options={data?.vendorCert}
                    value={certValue}
                    onChange={(value) => {
                      searchSelect("cert", value);
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>
                    <b>Search By Product/Service</b>
                    <Form.Check
                      className="mx-3"
                      inline
                      label="Has all jobs"
                      name="hasAllJobs"
                      type={"checkbox"}
                      id={`hasAllJobs`}
                      defaultChecked={JSON.parse(
                        filterParams?.hasAllJobs || false,
                      )}
                      onChange={(e) => handleFilterParamsChange(e)}
                    />
                  </Form.Label>

                  <Select
                    isMulti
                    classNamePrefix={"form-select"}
                    options={data?.vendorJobs}
                    value={jobsValue}
                    onChange={(value) => {
                      searchSelect("job", value);
                    }}
                  />
                </Form.Group>

                <div className="mb-2-5">
                  <Form.Check
                    inline
                    label="Enable Price Range"
                    name="enablePriceRange"
                    type={"checkbox"}
                    id={`enablePriceRange`}
                    defaultChecked={JSON.parse(
                      filterParams?.enablePriceRange || false,
                    )}
                    onChange={(e) => handleFilterParamsChange(e)}
                  />
                </div>

                {initialRanges.min > 0 || initialRanges.max > 0 ? (
                  <Form.Group className="my-3">
                    <Form.Label>
                      <b>Search By Range</b>
                    </Form.Label>
                    <MultiRangeSlider
                      min={initialRanges.min}
                      max={initialRanges.max}
                      onChange={(e) => {
                        setMax(e.max);
                        setMin(e.min);
                      }}
                      formatNumber={true}
                    />
                  </Form.Group>
                ) : null}
              </div>

              <div className="buttons rounded">
                <Button onClick={() => reset()} variant="white">
                  Reset
                </Button>
                <Button onClick={AddSelected} variant="primary">
                  Ok
                </Button>
              </div>
            </Form>

            {handleAdvanceSearchSelect && (
              <div>
                <Table borderless striped className="product-table">
                  <thead>
                    <tr>
                      <th />
                      <th>S/N</th>
                      <th>Vendor ID</th>
                      <th>Vendor Name</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.vendors &&
                      data.vendors.map((el, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              type="checkbox"
                              onChange={() => onSelected(el.Vendor_ID)}
                              checked={selectedData.find(
                                (id) => id === el.Vendor_ID,
                              )}
                            />
                          </td>

                          <td>{index + 1}</td>

                          <td>{el?.CompanyName}</td>
                          <td>{el?.Vendor_ID}</td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
